<template lang="pug">
  footer#footer(:class="{open: open}")
    template(v-for="(items, i) in navigation")
      nav-list(:items="items")
    #logos
      div
        img(src="static/BMBF_deutsch.jpg")
      div
        img(src="static/1_DSHS-Logo_Schwarz.jpg")
      div
        img(src="static/HSM_Logo_G_schwarz_klein_bold_regular.png")
      div
        img(src="static/motionbank_logo.svg")
      div
        img(src="static/logo-jgu.svg")
</template>

<script>
import NavList from './fragments/NavList'
export default {
  name: 'FooterComponent',
  components: {
    NavList
  },
  data () {
    return {
      navigation: {
        left: [
          {to: {name: 'content-page', params: {type: 'pages', id: 58}}, label: this.$t('labels.navigation.information')},
          {fn: this.toggleLogos, label: this.$t('labels.navigation.institutions')}
        ],
        center: [],
        right: []
      },
      open: false
    }
  },
  methods: {
    toggleLogos () {
      this.open = !this.open
    }
  }
}
</script>

<style scoped lang="stylus">
@import '../css/vars'
footer.open
  position fixed
  bottom 0
  left 0
  right 0
  height auto
  overflow auto

footer
  background-color $color-font-dark-gray
  color $color-bg-light-gray
  height 3rem
  font-size 0.8rem
  overflow hidden

  >>> nav
    padding 0.25rem
    padding-left 1.5rem

    @media screen and (max-width: $media-query-width-tablet)
      padding 0rem
      padding-left 1rem

    li
      float left
      padding 0.5rem
      margin-bottom 0.5rem

      @media screen and (max-width: $media-query-width-tablet)
        padding 0.25rem
        margin-bottom 0rem

      a
        background-color inherit

  @media screen and (max-width: $media-query-width-tablet)
    height 2rem

  #logos
    display flex
    flex-direction row
    width 100%
    height 300px
    background-color white
    position relative
    flex-wrap wrap

    @media screen and (max-width: $media-query-width-tablet)
      height 150px

    & > div
      flex-grow 1
      width calc(100% / 5)
      display flex
      flex-direction row
      justify-content center
      align-items center

      @media screen and (max-width: $media-query-width-mobile-l)
        width 100%
        padding 3rem

      img
        width 70%
        height auto
</style>



// WEBPACK FOOTER //
// src/components/FooterComponent.vue